/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DeptSearch', DeptSearch);

    DeptSearch.$inject = ['$resource'];

    function DeptSearch($resource) {
        var resourceUrl =  'api/_search/depts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
